<div class="terms-of-sale-wrapper">
  <div class="terms-of-sale-container">
    <h1 class="terms-title">{{ "TERMS_OF_SALE_PAGE.TITLE" | translate }}</h1>
    <section>
      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 1.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_1.DESC_1" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_1.DESC_2" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_1.DESC_3" | translate }}</p>
      </div>
  
      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 2.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_2.DESC_1" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_2.DESC_2" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_2.DESC_3" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_2.DESC_4" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_2.DESC_5" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_2.DESC_6" | translate }}</p>
      </div>
  
      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 3.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_3.DESC_1" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_3.DESC_2" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_3.DESC_3" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_3.DESC_4" | translate }}</p>
        <ol>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_3.DESC_5" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_3.DESC_6" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_3.DESC_7" | translate }}</li>
        </ol>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_3.DESC_8" | translate }}</p>
      </div>
  
      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 4.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_4.DESC_1" | translate }}</p>
      </div>
  
      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 5.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_5.DESC_1" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_5.DESC_2" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_5.DESC_3" | translate }}</p>
      </div>
  
      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 6.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_6.DESC_1" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_6.DESC_2" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_6.DESC_3" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_6.DESC_4" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_6.DESC_5" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_6.DESC_6" | translate }}</p>
      </div>
  
      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 7.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_7.DESC_1" | translate }}</p>
      </div>
  
      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 8.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_8.DESC_1" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_8.DESC_2" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_8.DESC_3" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_8.DESC_4" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_8.DESC_5" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_8.DESC_6" | translate }}</p>
      </div>
  
      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 9.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_9.DESC_1" | translate }}</p>
      </div>
  
      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 10.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_10.DESC_1" | translate }}</p>
      </div>
  
      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 11.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_11.DESC_1" | translate }}</p>
        <ol>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_11.DESC_2" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_11.DESC_3" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_11.DESC_4" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_11.DESC_5" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_11.DESC_6" | translate }}</li>
        </ol>
      </div>
  
      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 12.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_12.DESC_1" | translate }}</p>
        <ol>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_12.DESC_2" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_12.DESC_3" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_12.DESC_4" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_12.DESC_5" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_12.DESC_6" | translate }}</li>
        </ol>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_12.DESC_7" | translate }}</p>
      </div>
  
      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 13.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_13.DESC_1" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_13.DESC_2" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_13.DESC_3" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_13.DESC_4" | translate }}</p>
      </div>
  
      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 14.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_14.DESC_1" | translate }}</p>
        <ul>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_14.DESC_2" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_14.DESC_3" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_14.DESC_4" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_14.DESC_5" | translate }}</li>
        </ul>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_14.DESC_6" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_14.DESC_7" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_14.DESC_8" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_14.DESC_9" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_14.DESC_10" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_14.DESC_11" | translate }}</p>
      </div>

      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 15.</span></h2>
         <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_15.DESC_1" | translate }}</p>
      </div>

      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 16.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_16.DESC_1" | translate }}</p>
      </div>

      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 17.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_17.DESC_1" | translate }}</p>
      </div>

      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 18.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_18.DESC_1" | translate }}</p>
      </div>

      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 19.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_19.DESC_1" | translate }}</p>
        <ul>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_19.DESC_2" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_19.DESC_3" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_19.DESC_4" | translate }}</li>
        </ul>
      </div>

      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 20.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_20.DESC_1" | translate }}</p>
      </div>

      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 21.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_21.DESC_1" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_21.DESC_2" | translate }}</p>
      </div>

      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 22.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_22.DESC_1" | translate }}</p>
      </div>

      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 23.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_23.DESC_1" | translate }}</p>
        <ul>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_23.DESC_2" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_23.DESC_3" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_23.DESC_4" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_23.DESC_5" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_23.DESC_6" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_23.DESC_7" | translate }}</li>
          <li>{{ "TERMS_OF_SALE_PAGE.ARTICLE_23.DESC_8" | translate }}</li>
        </ul>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_23.DESC_9" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_23.DESC_10" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_23.DESC_11" | translate }}</p>
      </div>

      <div class="terms-section">
        <h2 class="terms-heading"><span class="bold">{{ "TERMS_OF_SALE_PAGE.ARTICLE" | translate }} 24.</span></h2>
        <p>{{ "TERMS_OF_SALE_PAGE.ARTICLE_24.DESC_1" | translate }}</p>
        <p class="mt-2">{{ "TERMS_OF_SALE_PAGE.ARTICLE_24.DESC_2" | translate }}</p>
      </div>
    </section>
  </div>
</div>